import { LoadState } from "../../constants/enums";

// ─── Message Types ────────────────────────────────────────────────────────────

export interface IChatMessage {
  id: string;
  role: "user" | "ai";
  content: string;
  timestamp: number;
  isStreaming?: boolean;
  error?: boolean;
}

// ─── Session Types ────────────────────────────────────────────────────────────

export interface ISession {
  session_id: string;
  title: string;
  created_at: string; // ISO date
  updated_at: string; // ISO date
}

export interface ISessionsState {
  list: ISession[];
  loading: LoadState;
  error: string | null;
  page: number;
  totalRecords: number;
  hasMore: boolean;
}

export interface ISessionsApiResponse {
  data: ISession[];
  totalRecords: number;
}

// ─── API Response Types ───────────────────────────────────────────────────────

export interface IHistoryContentPart {
  text: string;
  type: string;
}

export interface IHistoryContext {
  id: string;
  role: "user" | "ai" | "assistant";
  content: string | IHistoryContentPart[];
}

export interface IHistoryItem {
  agent_converstion_context_id: number;
  message_id: string;
  context: IHistoryContext;
  insert_ts?: string;
}

// ─── Redux State ──────────────────────────────────────────────────────────────

export interface IAiChatState {
  isOpen: boolean;
  messages: IChatMessage[];
  loading: boolean;
  fileContext: string | null;
  history: {
    loading: LoadState;
    error: string | null;
    page: number;
    hasMore: boolean;
  };
  activeSessionId: string | null;
  sessions: ISessionsState;
}

export const initialSessionsState: ISessionsState = {
  list: [],
  loading: LoadState.NotLoaded,
  error: null,
  page: 0,
  totalRecords: 0,
  hasMore: true,
};

export const initialAiChatState: IAiChatState = {
  isOpen: false,
  messages: [],
  loading: false,
  fileContext: null,
  history: {
    loading: LoadState.NotLoaded,
    error: null,
    page: 1,
    hasMore: true,
  },
  activeSessionId: null,
  sessions: initialSessionsState,
};
